var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['home','course','grade']}},[_c('router-view')],1),_c('messageToast',{ref:"toast"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }